import React from 'react';
// Components
import Navbar from '../../components/nav/Navbar';
import HomePageMainContainer from '../../components/home/HomePageMainContainer';
import HomePageHeader from '../../components/home/HomePageHeader';

const HomePage = React.memo(() => {
  return (
    <>
      {/* Page */}
      <div className='grid min-h-screen w-full overflow-hidden font-poppins bg-colour2 dark:bg-colour2 text-colour1 dark:text-colour1'>
        <div className='grid grid-rows-reg h-full'>
          {/* Navigation */}
          <Navbar />
          <HomePageHeader />
        </div>

        {/* Main page content */}
        <HomePageMainContainer />
      </div>
    </>
  );
});

export default HomePage;
